import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { ContextContract, ContextProject, ContextTree } from '@system/context/context.model';
import {
  ContextContractIds,
  ContextProgramIds,
  ContextProjectIds,
  ContextStoreActions,
  initialContextState as initialState,
} from './models';

export const ContextStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withDevtools('context'),
  withComputed(store => {
    const getProjects = () =>
      (store.programs() || []).reduce<ContextProject[]>((acc, program) => {
        return [...acc, ...(program.projects || [])];
      }, []);
    return {
      contractsName: computed(() => store.modules().CT?.name),
      projects: computed(() => getProjects()),
      contracts: computed(() =>
        getProjects().reduce<ContextContract[]>((acc, project) => {
          return [...acc, ...(project.contracts || [])];
        }, []),
      ),
    };
  }),
  withMethods(store => {
    return {
      set: (data: ContextTree) =>
        updateState(store, ContextStoreActions.SetContext, {
          ...data,
          modules: data.modules.reduce((acc, m) => ({ ...acc, [m.abbr]: m }), {}),
        }),
      getCurrency: (id: number) => store.currencies().find(c => c.currencyId === id),
      getProgram: ({ programId, entityInstanceId, no }: ContextProgramIds) =>
        store.programs().find(p => p.id === programId || p.entityInstanceId === entityInstanceId || p.no === no),
      getProject: ({ projectId, entityInstanceId, no }: ContextProjectIds) =>
        store.projects().find(p => p.id === projectId || p.entityInstanceId === entityInstanceId || p.no === no),
      getContract: ({ contractId, entityInstanceId, no }: ContextContractIds) =>
        store.contracts().find(c => c.id === contractId || c.entityInstanceId === entityInstanceId || c.no === no),
    };
  }),
);
